import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import dayjs from 'dayjs';

const DurationCell = ({ value }: GridRenderCellParams) => {
    return <div>{dayjs().to(value * 1000, true)}</div>;
};

export default DurationCell;
